import React from "react";
import { Link } from "react-router-dom";

const PLAN_LIMITS = {
  free: {
    ai: 5,
    image: 2,
    vision: 1,
    singing_coach: 1,
    singing_review: 1,
    voice: 1,
    health: 1,
    career: 1,
  },

  pro: {
    ai: 50,
    image: 20,
    vision: 3,
    singing_coach: 3,
    singing_review: 3,
    voice: 3,
    health: 3,
    career: 3,
  },

  ultra: {
    ai: 9999,
    image: 200,
    vision: 10,
    singing_coach: 10,
    singing_review: 10,
    voice: 10,
    health: 10,
    career: 10,
  },
};

function PlanCard({ title, price, limits, buttonText, onClick }) {
  return (
    <div
      style={{
        background: "#1f2937",
        padding: "20px",
        borderRadius: "12px",
        marginBottom: "20px",
        color: "white",
      }}
    >
      <h2>{title}</h2>
      <h3>{price}</h3>

      <ul>
        <li>AI Chats: {limits.ai}</li>
        <li>Image Generation: {limits.image}</li>
        <li>Vision AI: {limits.vision}</li>
        <li>Singing Coach: {limits.singing_coach}</li>
        <li>Singing Review: {limits.singing_review}</li>
        <li>Voice AI: {limits.voice}</li>
        <li>Health Reports: {limits.health}</li>
        <li>Career AI: {limits.career}</li>
      </ul>

      {buttonText && (
        <button
          onClick={onClick}
          style={{
            background: "#2563eb",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          {buttonText}
        </button>
      )}
    </div>
  );
}

export default function PlansPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#111827",
        padding: "30px",
        color: "white",
      }}
    >
      <h1>💎 VedAI Plans</h1>

      <PlanCard
        title="FREE"
        price="₹0"
        limits={PLAN_LIMITS.free}
      />

      <PlanCard
        title="PRO"
        price="₹199"
        limits={PLAN_LIMITS.pro}
        buttonText="Upgrade To PRO"
        onClick={() =>
          window.open("https://rzp.io/rzp/HI6kMUzd", "_blank")
        }
      />

      <PlanCard
        title="ULTRA"
        price="₹499"
        limits={PLAN_LIMITS.ultra}
        buttonText="Upgrade To ULTRA"
        onClick={() =>
          window.open("https://rzp.io/rzp/v4KihIr", "_blank")
        }
      />

      <Link to="/">
        <button
          style={{
            marginTop: "20px",
            padding: "10px 20px",
          }}
        >
          ← Back
        </button>
      </Link>
    </div>
  );
}